import React from 'react'
import { Form, Typography } from '@s4l/ds'
import { IconTrash } from '@s4l/icons/IconTrash'
import { useS4LContext } from '@s4l/react-context'
import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'
import { useSearchMetadata } from '../useSearchMetadata'

const FilterFacilities = () => {
  const { i18n } = useS4LContext()
  const { searchMetadata } = useSearchMetadata()

  const availableFacilities = [
    { id: 1, name: i18n.formatMessage({ id: 'global.car-park' }), slug: 'car-park' },
    { id: 2, name: i18n.formatMessage({ id: 'global.gym' }), slug: 'gym' },
    { id: 3, name: i18n.formatMessage({ id: 'global.indoor-pool' }), slug: 'indoor-pool' },
    { id: 4, name: i18n.formatMessage({ id: 'global.outdoor-pool' }), slug: 'outdoor-pool' },
    { id: 5, name: i18n.formatMessage({ id: 'global.airport-shuttle' }), slug: 'airport-shuttle' },
    { id: 6, name: i18n.formatMessage({ id: 'global.spa' }), slug: 'spa' },
    { id: 8, name: i18n.formatMessage({ id: 'global.wifi' }), slug: 'wi-fi' },
    {
      id: 7,
      name: i18n.formatMessage({ id: 'global.wheelchair' }),
      slug: 'wheelchair-access',
    },
  ]

  return (
    <Form.Fieldset>
      <Form.Legend>{i18n.formatMessage({ id: 'filter-category.hotel-facilities' })}</Form.Legend>
      <Form.ClearButton icon={<IconTrash />}>
        {i18n.formatMessage({ id: 'serp.filter-clear' })}
      </Form.ClearButton>
      {availableFacilities.map(facility => {
        const count = searchMetadata?.facilities?.getByKey(facility.slug)?.count ?? 0
        return (
          <Form.Label key={`facility-${facility.id}`}>
            {facility.name}
            {searchMetadata && (
              <Typography variant="caption" size="m" color="neutral-800">
                {count}
              </Typography>
            )}
            <Form.Checkbox
              disabled={searchMetadata && !count}
              name="facilities"
              multiple
              trueValue={facility.slug}
            />
          </Form.Label>
        )
      })}
    </Form.Fieldset>
  )
}

FilterFacilities.displayName = 'SearchFilters.FilterFacilities'
export default withErrorBoundary(FilterFacilities)
